/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgUserUpdatePvdConfigRequest
 */
export interface OrgUserUpdatePvdConfigRequest {
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdatePvdConfigRequest
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdatePvdConfigRequest
     */
    auth_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserUpdatePvdConfigRequest
     */
    new_pvd_config_id: string;
    /**
     * 
     * @type {boolean}
     * @memberof OrgUserUpdatePvdConfigRequest
     */
    should_force_apply: boolean;
}

/**
 * Check if a given object implements the OrgUserUpdatePvdConfigRequest interface.
 */
export function instanceOfOrgUserUpdatePvdConfigRequest(value: object): value is OrgUserUpdatePvdConfigRequest {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('auth_id' in value) || value['auth_id'] === undefined) return false;
    if (!('new_pvd_config_id' in value) || value['new_pvd_config_id'] === undefined) return false;
    if (!('should_force_apply' in value) || value['should_force_apply'] === undefined) return false;
    return true;
}

export function OrgUserUpdatePvdConfigRequestFromJSON(json: any): OrgUserUpdatePvdConfigRequest {
    return OrgUserUpdatePvdConfigRequestFromJSONTyped(json, false);
}

export function OrgUserUpdatePvdConfigRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserUpdatePvdConfigRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'auth_id': json['auth_id'],
        'new_pvd_config_id': json['new_pvd_config_id'],
        'should_force_apply': json['should_force_apply'],
    };
}

export function OrgUserUpdatePvdConfigRequestToJSON(json: any): OrgUserUpdatePvdConfigRequest {
    return OrgUserUpdatePvdConfigRequestToJSONTyped(json, false);
}

export function OrgUserUpdatePvdConfigRequestToJSONTyped(value?: OrgUserUpdatePvdConfigRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'auth_id': value['auth_id'],
        'new_pvd_config_id': value['new_pvd_config_id'],
        'should_force_apply': value['should_force_apply'],
    };
}

